import { Interval } from '@zapier/design-system-revenue/src/types';

export const buildUpgradeUrl = (
  currentPlanName: string,
  upgradeToPlanName: string,
  interval: Interval
) => {
  const currentPlanNameString = currentPlanName.toLowerCase();
  const upgradeToPlanNameString = upgradeToPlanName.toLowerCase();

  return currentPlanName && upgradeToPlanName
    ? encodeURI(
        `/app/billing/plans/upgrade/${currentPlanNameString}/${upgradeToPlanNameString}?interval=${interval}`
      )
    : '';
};
